import Box from "@/common/components/Box";
import BoxWithHeader from "@/common/components/BoxWithHeader";
import Button from "@/common/components/Button";
import Skeleton from "@/common/components/Skeleton";

const MaintenanceWorkflowDiagnosticEntryUpdateLoading = () => {
  return (
    <div className="flex-1 flex gap-6">
      <div className="flex-1">
        <Box className="p-4 flex flex-col gap-4">
          <div className="flex gap-3">
            <Skeleton className="size-72 rounded-lg" />

            <div className="flex flex-col gap-3 flex-1">
              <div className="flex flex-col gap-1">
                <Skeleton className="w-24 h-4" />

                <Skeleton className="bg-white-100 h-44" />
              </div>

              <div className="flex-1 flex flex-col gap-1">
                <Skeleton className="w-24 h-4" />

                <Skeleton className="bg-white-100 flex-1" />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <p className="text-lg font-medium">
                Objetos originais
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <Box className="flex items-center justify-between p-4 rounded-lg">
                <div className="flex items-center gap-4">
                  <div className="flex">
                    <Box className="p-2 flex items-center gap-2">
                      <Skeleton className="w-32 h-6" />
                    </Box>
                  </div>

                  <div className="flex flex-col gap-1">
                    <Skeleton className="w-48 h-6" />

                    <Skeleton className="w-60 h-4" />
                  </div>
                </div>

                <div className="flex gap-3">
                  <Button variant="outline-error" disabled>
                    <Skeleton className="w-32" />
                  </Button>

                  <Button variant="outline-success" disabled>
                    <Skeleton className="w-16" />
                  </Button>
                </div>
              </Box>
            </div>
          </div>
        </Box>
      </div>

      <div>
        <BoxWithHeader
          title="Checklist"
          subtitle="Diagnóstico e Orçamento"
        >
          <div className="flex flex-col gap-2">
            { }
          </div>

          <div className="flex flex-col gap-2">
            <Button variant="outline-disabled">
              Enviar diagnóstico e orçamento
            </Button>
          </div>
        </BoxWithHeader>
      </div>
    </div>
  );
}

export default MaintenanceWorkflowDiagnosticEntryUpdateLoading;
